import * as React from 'react';

import { getUserTimezone } from '@bondvet/web-app-lib/util/timezone';
import { graphql, useStaticQuery } from 'gatsby';
import { Location } from 'lib/types';

export const locationsWithTimezonesQuery = graphql`
    query LocationsWithTimezones {
        allLocation {
            nodes {
                _id
                timezone
            }
        }
    }
`;

export type LocationWithTimezone = Pick<Location, '_id' | 'timezone'>;

interface LocationsWithTimezonesQuery {
    allLocation: {
        nodes: ReadonlyArray<LocationWithTimezone>;
    };
}

export default function useLocationTimeZone(locationId?: string): string {
    const [timezone, setTimezone] = React.useState(
        () =>
            getUserTimezone() ||
            (process.env.GATSBY_DEFAULT_TIMEZONE as string),
    );
    const {
        allLocation: { nodes: locations },
    } = useStaticQuery<LocationsWithTimezonesQuery>(
        locationsWithTimezonesQuery,
    );

    React.useEffect(() => {
        if (locationId && locations?.length) {
            const selectedLocation = locations.find(
                (location) => location._id === locationId,
            );

            if (selectedLocation?.timezone) {
                setTimezone(selectedLocation.timezone);
            }
        }
    }, [locations, locationId]);

    return timezone;
}
